import React, { useState, useEffect } from 'react';
import './BinaryHotel.css';

function BinaryHotel() {
  // State for array, indices, history, and target
  const [array, setArray] = useState([]);
  const [left, setLeft] = useState(0);
  const [right, setRight] = useState(0);
  const [middle, setMiddle] = useState(0);
  const [history, setHistory] = useState([]);
  const [target, setTarget] = useState(null);
  const [message, setMessage] = useState('');

  // Move the initialization logic to a separate function
  const initializeGame = () => {
    const size = 2048;
    const uniqueNumbers = new Set();
    
    // Generate unique numbers between 1 and 9999
    while (uniqueNumbers.size < size) {
      uniqueNumbers.add(Math.floor(Math.random() * 9999) + 1);
    }
    
    const newArray = Array.from(uniqueNumbers).sort((a, b) => a - b);
    
    // Start from the middle
    let currentIndex = Math.floor((size - 1) / 2);
    
    // Make 5 random moves
    for (let i = 0; i < 5; i++) {
      const goLeft = Math.random() < 0.5;
      const rangeSize = Math.max(1, Math.floor((size - 1) / Math.pow(2, i + 2)));
      
      if (goLeft) {
        currentIndex = Math.max(0, currentIndex - rangeSize);
      } else {
        currentIndex = Math.min(size - 1, currentIndex + rangeSize);
      }
    }
    
    const randomTarget = newArray[currentIndex];
    
    setArray(newArray);
    setRight(newArray.length - 1);
    setLeft(0);
    setMiddle(Math.floor((newArray.length - 1) / 2));
    setTarget(randomTarget);
    setHistory([]);
    setMessage('');
  };

  // Use initializeGame in useEffect
  useEffect(() => {
    initializeGame();
  }, []);

  // Check if current room matches target whenever middle changes
  useEffect(() => {
    if (array[middle] === target) {
      setMessage(`Congratulations! You found room ${target}!`);
    } else if (array.length > 0) {  // Only show message if array is populated
      setMessage(`Keep searching!`);
    }
  }, [middle, array, target]);

  const moveLeft = () => {
    if (left >= right) return;
    setHistory([...history, { middle, left, right }]);
    setRight(middle - 1);
    setMiddle(Math.floor((left + (middle - 1)) / 2));
  };

  const moveRight = () => {
    if (left >= right) return;
    setHistory([...history, { middle, left, right }]);
    setLeft(middle + 1);
    setMiddle(Math.floor((middle + 1 + right) / 2));
  };

  const goBack = () => {
    if (history.length === 0) return;
    const prevState = history[history.length - 1];
    setHistory(history.slice(0, -1));
    setMiddle(prevState.middle);
    setLeft(prevState.left);
    setRight(prevState.right);
  };

  return (
    <div className="binary-hotel">
      <div className="target-display">
        Find room number: {target}
      </div>
      
      <div className="hotel-display">
        <button 
          className="nav-button left"
          onClick={moveLeft}
          aria-label="Go left"
        >
          ←
        </button>
        
        <div className="door">
          <div className="room-number">{array[middle]}</div>
        </div>
        
        <button 
          className="nav-button right"
          onClick={moveRight}
          aria-label="Go right"
        >
          →
        </button>
      </div>

      <div className="controls">
        <button 
          className="back-button"
          onClick={goBack}
          disabled={history.length === 0}
        >
          Back
        </button>
        <button 
          className="new-game-button"
          onClick={initializeGame}
        >
          New Game
        </button>
      </div>

      {message && (
        <div className="message">
          {message}
        </div>
      )}
    </div>
  );
}

export default BinaryHotel; 